import { ProductVertical, ProductVerticalProps } from './product-vertical'

import * as gtm from '../../services/gtm'

import { Product } from 'src/services/searchProducts/dtos'
import { ProductApi } from 'src/types'

type ProductVerticalWithAnalyticsProps = {
  analyticsProduct?: ProductApi | Product
  isFavoritos?: boolean
  shouldSendGoogleAnalyticsEventRequest?: boolean
} & ProductVerticalProps

export const ProductVerticalWithAnalytics = ({
  analyticsProduct,
  product,
  onClick,
  shouldSendGoogleAnalyticsEventRequest = true,
  ...rest
}: ProductVerticalWithAnalyticsProps) => {
  const sendToGoogleAnalytics = () => {
    if (analyticsProduct?.selectedSku) {
      gtm.productClick(analyticsProduct)
    }
  }

  const handleProductClick = async (
    product: ProductVerticalProps['product']
  ) => {
    if (shouldSendGoogleAnalyticsEventRequest) {
      sendToGoogleAnalytics()
    }

    onClick?.(product)
  }

  return (
    <ProductVertical product={product} onClick={handleProductClick} {...rest} />
  )
}
